<template>
    <div class="org-verfiy-mobile">
        <bind-mobile-number ref="unbind" />
        <verify-phone-code ref="verify" :verify-params="verifyParams" @passVerify="passVerify" @cancel="cancelPass" />
    </div>
</template>
<script>
import bindMobileNumber from './components/Bind-mobile-number.vue';
import verifyPhoneCode from './components/verify-phone-code';
import { VERIFY_STATUS } from './constants';
import { commonData } from '@/config/qdAdminCommon';
import { getLoginAccount } from '@tencent/qd-lib';

export default {
    name: 'creat-user-check-phone',
    components: {
        bindMobileNumber,
        verifyPhoneCode
    },

    props: {
        staffIdArr: {
            type: Array,
            default() {
                return [];
            }
        }
    },

    data() {
        return {
            mobile: '',
            isMobileBind: false,
            verifyParams: {},
            verifyPromise: {},
            info: commonData?.profile || {},
        };
    },

    methods: {
        mobileVerify(mobile) {
            return new Promise((resolve, reject) => {
                const verifyPromise = { resolve, reject };
                if (mobile) {
                    // 绑定过手机，需要校验手机号，发送验证码
                    console.log('有手机号，拉起验证码');
                    this.verifyParams.mobile = mobile;
                    this.$refs.verify.dialogShow = true;
                    this.verifyPromise = verifyPromise;
                } else {
                    console.log('没手机号');
                    // 没绑定过手机，弹框引导绑定手机号
                    this.$refs.unbind.dialogShow = true;
                    resolve({ verifyStatus: VERIFY_STATUS.unbind });
                }
            });
        },

        passVerify({ sms_code, sms_mobile }) {
            if (this.verifyPromise) {
                this.verifyPromise.resolve({ verifyStatus: VERIFY_STATUS.hasSendCode, sms_code, sms_mobile });
            }
        },
        cancelPass() {
            this.verifyPromise.resolve({ verifyStatus: VERIFY_STATUS.cancel });
        },

        getPhone() {
            return new Promise((resolve, reject) => {
                this.getBindData()
                    .then(mobileData => {
                        console.log('getPhone 有手机号');
                        const { mobile } = mobileData || {};
                        resolve({ mobile });
                    })
                    .catch(() => {
                        console.log('getPhone 没有手机号');
                        this.$refs.unbind.dialogShow = true;
                        resolve({ mobile: '' });
                    });
            });
        },

        getBindData() {
            return new Promise((resolve, reject) => {
                const bindPromise = { resolve, reject };
                let mobileInfo = {};

                if (this.info.isAdmin) {
                    if (window.SSR_DATA.info.contactMobile) {
                        mobileInfo = {
                            mobile: window.SSR_DATA.info.contactMobile,
                            isMobileBind: 1
                        };
                        this.handleBindData(mobileInfo, bindPromise);
                    } else {
                        this.$ajax.get('/mng/account/contacts/index').then(res => {
                            const { contactMobile } = res || {};

                            if (contactMobile) {
                                window.SSR_DATA.info.contactMobile = contactMobile;
                                mobileInfo = {
                                    mobile: contactMobile,
                                    isMobileBind: 1
                                };
                                this.handleBindData(mobileInfo, bindPromise);
                            } else {
                                this.$message.error('获取联系人手机号失败');
                            }
                        });
                    }
                } else {
                    this.$ajax.gatewayPost('/v1/basic.account.account_web.Account/AidMobile', { aid: Number(getLoginAccount()) }).then((res) => {
                        const mobile = (res.data && res.data.mobile) || '';
                        mobileInfo = {
                            mobile,
                            isMobileBind: mobile.length > 0 ? 1 : 0,
                        };
                    });
                    this.handleBindData(mobileInfo, bindPromise);
                }
            });
        },

        handleBindData(mobileInfo, bindPromise) {
            console.log('mobileInfo==', mobileInfo);
            const { mobile, isMobileBind } = mobileInfo || {};

            if (!mobile || !isMobileBind) {
                bindPromise.reject({ msg: '请先绑定手机号！' });
            } else {
                // 绑定过手机了，直接拉起验证码
                bindPromise.resolve(mobileInfo);
            }
        }
    }
};
</script>
